import { render, staticRenderFns } from "./PageTransition.vue?vue&type=template&id=605977be&scoped=true&"
import script from "./PageTransition.vue?vue&type=script&lang=js&"
export * from "./PageTransition.vue?vue&type=script&lang=js&"
import style0 from "./PageTransition.vue?vue&type=style&index=0&id=605977be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605977be",
  null
  
)

export default component.exports